.rows {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 52px;
  padding: 8px 18px;
  border-top: 1.5px solid var(--ink);
}

.link {
  color: inherit;
  text-decoration: none;
}

.link:hover .label {
  text-decoration: underline;
}

.label {
  color: var(--ink-2);
}

.value {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  text-align: right;
}

.skipped {
  color: var(--ink-3);
}

/* The mood's colour from the chart, always beside its name. */
.swatch {
  width: 14px;
  height: 22px;
  flex: 0 0 auto;
  border: 1.5px solid var(--ink);
  border-radius: 3px;
  background: var(--swatch);
}
